import { AxiosInstance } from 'axios'
import { BaseListParams, PaginatedResponse } from '../../base.type'
import { Catalog, CatalogCreate, CatalogUpdate } from '../catalog.type'

export class DepartmentApi {
    constructor(private readonly client: AxiosInstance) {}

    /**
     * Get all departments with pagination
     */
    async list(params?: BaseListParams): Promise<PaginatedResponse<Catalog>> {
        const response = await this.client.get<PaginatedResponse<Catalog>>('/departments', {
            params,
        })
        return response.data
    }

    /**
     * Get a single department by ID
     */
    async findOne(id: string): Promise<Catalog> {
        const response = await this.client.get<Catalog>(`/departments/${id}`)
        return response.data
    }

    /**
     * Create a new department
     */
    async create(payload: CatalogCreate): Promise<Catalog> {
        const response = await this.client.post<Catalog>('/departments', payload)
        return response.data
    }

    /**
     * Update a department
     */
    async update(id: string, payload: CatalogUpdate): Promise<Catalog> {
        const response = await this.client.put<Catalog>(`/departments/${id}`, payload)
        return response.data
    }

    /**
     * Delete a department
     */
    async delete(id: string): Promise<void> {
        await this.client.delete(`/departments/${id}`)
    }
}
